import { useEffect, Suspense } from 'react';
import { Provider, useSelector } from 'react-redux';

import { Loader } from 'components/Loader';
import SessionExpiredModal from 'components/SessionExpiredModal';
import ToastMessages from 'components/ToastMessages/ToastMessages';

import { ToastProvider } from 'contexts/ToastContext';

import { useDatadog } from 'hooks/useDatadog';
import { useSessionExpired } from 'hooks/useSessionExpired';

import { selectUser } from 'sideEffects/selectors';
import store from 'sideEffects/store';

import { registerSessionExpiredHandler } from 'utils/httpInterceptor';

import AppRoutes from './AppRoutes';
import ScrollToTop from './ScrollToTop';

const AppContent = () => {
  const user = useSelector(selectUser);
  const { initDatadogSession, identifyDatadogUser } = useDatadog();

  initDatadogSession();

  useEffect(() => {
    if (user?.personalInfo?.email) {
      identifyDatadogUser(user.personalInfo.email);
    }
  }, [user?.personalInfo?.email]);

  const { isSessionExpiredModalOpen, handleSessionExpired, handleRedirectToLogin } = useSessionExpired();

  useEffect(() => {
    registerSessionExpiredHandler(handleSessionExpired);
  }, [handleSessionExpired]);

  return (
    <>
      <ScrollToTop />
      <AppRoutes />
      {isSessionExpiredModalOpen && <SessionExpiredModal open onRedirect={handleRedirectToLogin} />}
    </>
  );
};

const App = () => {
  return (
    <Provider store={store}>
      <ToastProvider>
        <ToastMessages />
        <Suspense fallback={<Loader />}>
          <AppContent />
        </Suspense>
      </ToastProvider>
    </Provider>
  );
};

export default App;
